import { Dayjs } from 'dayjs';
import { TypeBaseEnum } from './enums/type-base-enum.model';
import { TypeOptionEnum } from './enums/type-option-enum.model';

export class Option {
  id?: string;
  reference: string;
  companyId?: number;
  countryId?: number;
  optionType: TypeOptionEnum;
  base: TypeBaseEnum;
  min?: number;
  max?: number;
  imageUrl?: string;
  startDate?: Dayjs;
  endDate?: Dayjs;
  // Key: language code (e.g., 'en', 'fr'), Value: translated text
  translations: { [key: string]: { name: string; description: string } };
}
